import {Component, inject} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import {BaseStateReportWidget} from '../base-state-report-widget';
import html2canvas from 'html2canvas';
import {rxResource} from '@angular/core/rxjs-interop';
import {HttpClient} from '@angular/common/http';
import {SanitizePipe} from '../../../../../../../shared/pipes/sanitize.pipe';
import JSZip from 'jszip';

@Component({
  selector: 'tgrid-resiliency-overview-widget',
  imports: [
    MatCard,
    MatCardContent,
    MatCardTitle,
    MatIconButton,
    VulcanIconComponent,
    SanitizePipe,
  ],
  templateUrl: './resiliency-overview-widget.component.html',
  styleUrl: './resiliency-overview-widget.component.scss',
  standalone: true,
})
export class ResiliencyOverviewWidgetComponent extends BaseStateReportWidget {
  private http = inject(HttpClient);

  protected resource = rxResource({
    request: () => {
      return { stateAbbreviation: this.stateParam() };
    },
    loader: ({ request }) => {
      return this.http.get(
        `api/curve/system-resiliency/${request.stateAbbreviation}/stats`,
        { responseType: 'text' },
      );
    },
  });

  protected override async export(): Promise<void> {
    const filename = `resiliency_stats_${this.stateParam()}`;
    const zip = new JSZip();

    const textContent = this.exportContent()?.nativeElement.innerText;
    const textBlob = new Blob([textContent], { type: 'text/plain' });
    zip.file(`${filename}.txt`, textBlob);

    try {
      const canvas = await html2canvas(this.exportContent()?.nativeElement);
      const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve));
      if (blob) {
        zip.file(`${filename}.png`, blob);
        const content = await zip.generateAsync({ type: 'blob' });
        const url = URL.createObjectURL(content);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}.zip`;
        link.click();
        URL.revokeObjectURL(url);
      }
      this.snackBar.open('Export downloaded successfully', 'Close', { duration: 3000 });
    } catch (err) {
      console.error(err);
      this.snackBar.open('Export failed. Please try again.', 'Close', { duration: 3000 });
    }
  }
}
